import React from "react";

function BackCover({ reportNumber, genDate }) {
  return (
    <div className="lr2-report">
      <div className="lr2-back" id="back">
        <svg viewBox="0 0 140 122" fill="none" xmlns="http://www.w3.org/2000/svg" style={{width:130,height:113,marginBottom:28}}>
          <polygon points="70,10 128,112 12,112" stroke="#C9A84C" strokeWidth="1.5" fill="rgba(201,168,76,0.05)"/>
          <line x1="70" y1="10" x2="70" y2="112" stroke="#C9A84C" strokeWidth="0.5" strokeDasharray="3,4" opacity="0.4"/>
          <line x1="12" y1="112" x2="128" y2="112" stroke="#C9A84C" strokeWidth="0.5" strokeDasharray="3,4" opacity="0.4"/>
          <line x1="70" y1="10" x2="12" y2="112" stroke="#C9A84C" strokeWidth="0.5" strokeDasharray="3,4" opacity="0.4"/>
          <circle cx="70" cy="72" r="4" fill="#C9A84C" opacity="0.7"/>
          <text x="70" y="6" textAnchor="middle" fill="#846B32" fontSize="9" fontFamily="serif">性格洞察</text>
          <text x="4" y="119" textAnchor="start" fill="#846B32" fontSize="9" fontFamily="serif">环境调适</text>
          <text x="136" y="119" textAnchor="end" fill="#846B32" fontSize="9" fontFamily="serif">主观能动</text>
          <text x="70" y="78" textAnchor="middle" fill="#A07820" fontSize="8" fontFamily="sans-serif">澄光</text>
        </svg>
        <div className="lr2-back-title">澄光能量 · 三维模型</div>
        <div className="lr2-back-sub">THE LUMINAARC THREE-AXIS ENERGY FRAMEWORK</div>
        <ul className="lr2-ethics">
          <li><span className="lr2-ethics-dot"/><span className="lr2-ethics-text">不使用恐吓性语言——所有解读均附带具体的应对方向，命理是镜子，不是判决书</span></li>
          <li><span className="lr2-ethics-dot"/><span className="lr2-ethics-text">不推销"转运服务"——能量调和需要你自己的参与，没有任何外力可以代替你的觉知与行动</span></li>
          <li><span className="lr2-ethics-dot"/><span className="lr2-ethics-text">鼓励实证：记录你的观察，以实际生活变化验证报告的洞见，而非盲目信从</span></li>
          <li><span className="lr2-ethics-dot"/><span className="lr2-ethics-text">尊重自由意志：命盘描述倾向与可能，而非宿命。你永远是能量流动的主体</span></li>
        </ul>
        <div className="lr2-back-foot">
          lumarcai.com &nbsp;·&nbsp; info@lumarcai.com<br/>
          报告编号 {reportNumber} &nbsp;·&nbsp; 生成日期 {genDate} &nbsp;·&nbsp; 版本 v2.0<br/>
          © 2026 THE LUMINAARC &nbsp;·&nbsp; 澄光能量 &nbsp;·&nbsp; 澄净智慧 · 自知自由
          <small>本报告基于中国传统命理学分析，仅供参考。不构成医疗、法律、金融投资建议。</small>
        </div>
      </div>
    </div>
  );
}

export default BackCover;
